import React, { useState, useEffect } from 'react';
import { 
  Save, 
  X, 
  Plus,
  Building2,
  User,
  MapPin,
  FileText,
  Ship,
  Mail,
  Phone,
  Trash2,
  Edit,
  ArrowLeft
} from 'lucide-react';

const ModifierClient = () => {
  const [formData, setFormData] = useState({
    // Informations principales
    customer_code: '',
    social_reason: '',
    siren: '',
    naf: '',
    tva_number: '',
    logo_url: '',
    code_comptable: '',
    notes: '',
    statut: 'Actif',
    
    // Adresse
    adresse: '',
    postal_code: '',
    city: '',
    country: 'France',
    
    // Destinataires
    recipients: [],
    
    // Contacts
    contacts: []
  });

  const [activeTab, setActiveTab] = useState('general');
  const [showRecipientModal, setShowRecipientModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [editingRecipient, setEditingRecipient] = useState(null);
  const [editingContact, setEditingContact] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const [tempRecipient, setTempRecipient] = useState({
    label: '',
    imo_number: '',
    type: 'Company',
    adresse: '',
    postal_code: '',
    city: '',
    country: 'France',
    notes: ''
  });

  const [tempContact, setTempContact] = useState({
    name: '',
    email: '',
    telephone: '',
    notes: ''
  });

  const pays = [
    'France', 'Allemagne', 'Italie', 'Espagne', 'Pays-Bas', 'Belgique', 'Luxembourg',
    'Suisse', 'Autriche', 'Danemark', 'Suède', 'Norvège', 'Finlande', 'Pologne',
    'République tchèque', 'Slovaquie', 'Hongrie', 'Roumanie', 'Bulgarie', 'Croatie',
    'Slovénie', 'Estonie', 'Lettonie', 'Lituanie', 'Malte', 'Chypre', 'Irlande',
    'Royaume-Uni', 'Portugal', 'Grèce', 'Japon', 'Chine', 'Corée du Sud', 'Singapour',
    'États-Unis', 'Canada', 'Australie', 'Nouvelle-Zélande'
  ];

  // Simulation du chargement d'un client existant
  useEffect(() => {
    // Simuler un appel API pour récupérer le client
    setTimeout(() => {
      const mockClient = {
        id: 1,
        customer_code: 'CMA001',
        social_reason: 'CMA CGM',
        siren: '123456789',
        naf: '5010',
        tva_number: 'FR12345678901',
        logo_url: '/logos/cmacgm.png',
        adresse: '4 Quai d\'Arenc',
        postal_code: '13002',
        city: 'Marseille',
        country: 'France',
        code_comptable: 'CMA001',
        notes: 'Client principal - Transport maritime. Spécialisé dans le transport de conteneurs et la logistique portuaire.',
        statut: 'Actif',
        recipients: [
          {
            id: 1,
            label: 'CMA CGM Marseille',
            imo_number: 'IMO1234567',
            type: 'Company',
            adresse: '4 Quai d\'Arenc',
            postal_code: '13002',
            city: 'Marseille',
            country: 'France',
            notes: 'Siège principal et terminal principal'
          }
        ],
        contacts: [
          {
            id: 1,
            name: 'Jean Dupont',
            email: 'contact@cmacgm.com',
            telephone: '+33 1 23 45 67 89',
            notes: 'Contact principal - Responsable logistique'
          }
        ]
      };
      
      setFormData(mockClient);
      setIsLoading(false);
    }, 1000);
  }, []);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleRecipientSubmit = () => {
    if (editingRecipient !== null) {
      // Modification d'un destinataire existant
      const updatedRecipients = [...formData.recipients];
      updatedRecipients[editingRecipient] = { ...tempRecipient, id: Date.now() };
      setFormData(prev => ({ ...prev, recipients: updatedRecipients }));
      setEditingRecipient(null);
    } else {
      // Ajout d'un nouveau destinataire
      setFormData(prev => ({
        ...prev,
        recipients: [...prev.recipients, { ...tempRecipient, id: Date.now() }]
      }));
    }
    
    setTempRecipient({
      label: '',
      imo_number: '',
      type: 'Company',
      adresse: '',
      postal_code: '',
      city: '',
      country: 'France',
      notes: ''
    });
    setShowRecipientModal(false);
  };

  const handleContactSubmit = () => {
    if (editingContact !== null) {
      // Modification d'un contact existant
      const updatedContacts = [...formData.contacts];
      updatedContacts[editingContact] = { ...tempContact, id: Date.now() };
      setFormData(prev => ({ ...prev, contacts: updatedContacts }));
      setEditingContact(null);
    } else {
      // Ajout d'un nouveau contact
      setFormData(prev => ({
        ...prev,
        contacts: [...prev.contacts, { ...tempContact, id: Date.now() }]
      }));
    }
    
    setTempContact({
      name: '',
      email: '',
      telephone: '',
      notes: ''
    });
    setShowContactModal(false);
  };

  const editRecipient = (index) => {
    setEditingRecipient(index);
    setTempRecipient({ ...formData.recipients[index] });
    setShowRecipientModal(true);
  };

  const editContact = (index) => {
    setEditingContact(index);
    setTempContact({ ...formData.contacts[index] });
    setShowContactModal(true);
  };

  const deleteRecipient = (index) => {
    const updatedRecipients = formData.recipients.filter((_, i) => i !== index);
    setFormData(prev => ({ ...prev, recipients: updatedRecipients }));
  };

  const deleteContact = (index) => {
    const updatedContacts = formData.contacts.filter((_, i) => i !== index);
    setFormData(prev => ({ ...prev, contacts: updatedContacts }));
  };

  const isFormValid = () => {
    return formData.social_reason && formData.customer_code;
  };

  const handleSubmit = () => {
    if (isFormValid()) {
      console.log('Données du client modifié:', formData);
      // Ici, vous ajouteriez la logique pour sauvegarder les modifications
      alert('Client modifié avec succès !');
    }
  };

  const tabs = [
    { id: 'general', label: 'Informations générales', icon: Building2 },
    { id: 'address', label: 'Adresse', icon: MapPin },
    { id: 'recipients', label: 'Destinataires', icon: Ship },
    { id: 'contacts', label: 'Contacts', icon: User }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'general':
        return (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Code client *
                </label>
                <input
                  type="text"
                  value={formData.customer_code}
                  onChange={(e) => handleInputChange('customer_code', e.target.value)}
                  placeholder="CMA001"
                  className="input-field"
                  maxLength={8}
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Raison sociale *
                </label>
                <input
                  type="text"
                  value={formData.social_reason}
                  onChange={(e) => handleInputChange('social_reason', e.target.value)}
                  placeholder="Nom de l'entreprise"
                  className="input-field"
                  maxLength={100}
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  SIREN
                </label>
                <input
                  type="text"
                  value={formData.siren}
                  onChange={(e) => handleInputChange('siren', e.target.value)}
                  placeholder="123456789"
                  className="input-field"
                  maxLength={9}
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Code NAF
                </label>
                <input
                  type="text"
                  value={formData.naf}
                  onChange={(e) => handleInputChange('naf', e.target.value)}
                  placeholder="5010"
                  className="input-field"
                  maxLength={5}
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Numéro de TVA
                </label>
                <input
                  type="text"
                  value={formData.tva_number}
                  onChange={(e) => handleInputChange('tva_number', e.target.value)}
                  placeholder="FR12345678901"
                  className="input-field"
                  maxLength={20}
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Code comptable
                </label>
                <input
                  type="text"
                  value={formData.code_comptable}
                  onChange={(e) => handleInputChange('code_comptable', e.target.value)}
                  placeholder="Code comptable"
                  className="input-field"
                  maxLength={100}
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  URL du logo
                </label>
                <input
                  type="url"
                  value={formData.logo_url}
                  onChange={(e) => handleInputChange('logo_url', e.target.value)}
                  placeholder="https://example.com/logo.png"
                  className="input-field"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Statut
                </label>
                <select
                  value={formData.statut}
                  onChange={(e) => handleInputChange('statut', e.target.value)}
                  className="input-field"
                >
                  <option value="Actif">Actif</option>
                  <option value="Inactif">Inactif</option>
                </select>
              </div>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-port-gray-700 mb-2">
                Notes
              </label>
              <textarea
                value={formData.notes}
                onChange={(e) => handleInputChange('notes', e.target.value)}
                placeholder="Notes sur le client..."
                rows={4}
                className="input-field"
              />
            </div>
          </div>
        );

      case 'address':
        return (
          <div className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-port-gray-700 mb-2">
                Adresse
              </label>
              <textarea
                value={formData.adresse}
                onChange={(e) => handleInputChange('adresse', e.target.value)}
                placeholder="Adresse complète"
                rows={3}
                className="input-field"
              />
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Code postal
                </label>
                <input
                  type="text"
                  value={formData.postal_code}
                  onChange={(e) => handleInputChange('postal_code', e.target.value)}
                  placeholder="13002"
                  className="input-field"
                  maxLength={10}
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Ville
                </label>
                <input
                  type="text"
                  value={formData.city}
                  onChange={(e) => handleInputChange('city', e.target.value)}
                  placeholder="Marseille"
                  className="input-field"
                  maxLength={100}
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Pays
                </label>
                <select
                  value={formData.country}
                  onChange={(e) => handleInputChange('country', e.target.value)}
                  className="input-field"
                >
                  {pays.map(pays => (
                    <option key={pays} value={pays}>{pays}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        );

      case 'recipients':
        return (
          <div className="space-y-6">
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-medium text-port-gray-900">Destinataires ({formData.recipients.length})</h3>
              <button
                onClick={() => setShowRecipientModal(true)}
                className="btn-primary flex items-center space-x-2"
              >
                <Plus className="h-4 w-4" />
                <span>Ajouter un destinataire</span>
              </button>
            </div>
            
            {formData.recipients.length === 0 ? (
              <div className="text-center py-8 text-port-gray-500">
                <Ship className="h-12 w-12 mx-auto mb-3 opacity-50" />
                <p>Aucun destinataire défini</p>
                <p className="text-sm">Ajoutez des destinataires pour ce client</p>
              </div>
            ) : (
              <div className="space-y-4">
                {formData.recipients.map((recipient, index) => (
                  <div key={recipient.id} className="card p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        {recipient.type === 'Ship' ? (
                          <Ship className="h-5 w-5 text-atl-blue-600" />
                        ) : (
                          <Building2 className="h-5 w-5 text-atl-green-600" />
                        )}
                        <div>
                          <div className="font-medium text-port-gray-900">{recipient.label}</div>
                          <div className="text-sm text-port-gray-600">
                            {recipient.type} • {recipient.city}, {recipient.country}
                          </div>
                          {recipient.imo_number && (
                            <div className="text-xs text-port-gray-500">IMO: {recipient.imo_number}</div>
                          )}
                        </div>
                      </div>
                      <div className="flex items-center space-x-2">
                        <button
                          onClick={() => editRecipient(index)}
                          className="text-atl-blue-600 hover:text-atl-blue-700"
                        >
                          <Edit className="h-4 w-4" />
                        </button>
                        <button
                          onClick={() => deleteRecipient(index)}
                          className="text-red-600 hover:text-red-700"
                        >
                          <Trash2 className="h-4 w-4" />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        );

      case 'contacts':
        return (
          <div className="space-y-6">
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-medium text-port-gray-900">Contacts ({formData.contacts.length})</h3>
              <button
                onClick={() => setShowContactModal(true)}
                className="btn-primary flex items-center space-x-2"
              >
                <Plus className="h-4 w-4" />
                <span>Ajouter un contact</span>
              </button>
            </div>
            
            {formData.contacts.length === 0 ? (
              <div className="text-center py-8 text-port-gray-500">
                <User className="h-12 w-12 mx-auto mb-3 opacity-50" />
                <p>Aucun contact défini</p>
                <p className="text-sm">Ajoutez des contacts pour ce client</p>
              </div>
            ) : (
              <div className="space-y-4">
                {formData.contacts.map((contact, index) => (
                  <div key={contact.id} className="card p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <User className="h-5 w-5 text-atl-blue-600" />
                        <div>
                          <div className="font-medium text-port-gray-900">{contact.name}</div>
                          <div className="text-sm text-port-gray-600">{contact.email}</div>
                          <div className="text-sm text-port-gray-600">{contact.telephone}</div>
                        </div>
                      </div>
                      <div className="flex items-center space-x-2">
                        <button
                          onClick={() => editContact(index)}
                          className="text-atl-blue-600 hover:text-atl-blue-700"
                        >
                          <Edit className="h-4 w-4" />
                        </button>
                        <button
                          onClick={() => deleteContact(index)}
                          className="text-red-600 hover:text-red-700"
                        >
                          <Trash2 className="h-4 w-4" />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        );

      default:
        return null;
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-atl-blue-600 mx-auto mb-4"></div>
          <p className="text-port-gray-600">Chargement du client...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* En-tête */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <button 
            onClick={() => window.history.back()}
            className="btn-secondary flex items-center space-x-2"
          >
            <ArrowLeft className="h-5 w-5" />
            <span>Retour</span>
          </button>
          <div>
            <h1 className="text-3xl font-bold text-port-gray-900">Modifier le client</h1>
            <p className="text-port-gray-600">Modifier les informations de {formData.social_reason}</p>
          </div>
        </div>
        <div className="flex items-center space-x-3">
          <button className="btn-secondary flex items-center space-x-2">
            <X className="h-5 w-5" />
            <span>Annuler</span>
          </button>
          <button 
            onClick={handleSubmit}
            disabled={!isFormValid()}
            className="btn-primary flex items-center space-x-2"
          >
            <Save className="h-5 w-5" />
            <span>Enregistrer</span>
          </button>
        </div>
      </div>

      {/* Onglets */}
      <div className="border-b border-port-gray-200">
        <nav className="-mb-px flex space-x-8">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-2 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 ${
                  activeTab === tab.id
                    ? 'border-atl-blue-500 text-atl-blue-600'
                    : 'border-transparent text-port-gray-500 hover:text-port-gray-700 hover:border-port-gray-300'
                }`}
              >
                <Icon className="h-4 w-4" />
                <span>{tab.label}</span>
              </button>
            );
          })}
        </nav>
      </div>

      {/* Contenu des onglets */}
      <div className="card p-6">
        {renderTabContent()}
      </div>

      {/* Modal Destinataire */}
      {showRecipientModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-2xl mx-4">
            <h3 className="text-lg font-semibold mb-4 flex items-center">
              <Ship className="h-5 w-5 mr-2" />
              {editingRecipient !== null ? 'Modifier le destinataire' : 'Nouveau destinataire'}
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Label *
                </label>
                <input
                  type="text"
                  value={tempRecipient.label}
                  onChange={(e) => setTempRecipient(prev => ({ ...prev, label: e.target.value }))}
                  placeholder="Nom du destinataire"
                  className="input-field"
                  maxLength={100}
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Type
                </label>
                <select
                  value={tempRecipient.type}
                  onChange={(e) => setTempRecipient(prev => ({ ...prev, type: e.target.value }))}
                  className="input-field"
                >
                  <option value="Ship">Navire</option>
                  <option value="Company">Entreprise</option>
                  <option value="Other">Autre</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Numéro IMO
                </label>
                <input
                  type="text"
                  value={tempRecipient.imo_number}
                  onChange={(e) => setTempRecipient(prev => ({ ...prev, imo_number: e.target.value }))}
                  placeholder="IMO1234567"
                  className="input-field"
                  maxLength={50}
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Pays
                </label>
                <select
                  value={tempRecipient.country}
                  onChange={(e) => setTempRecipient(prev => ({ ...prev, country: e.target.value }))}
                  className="input-field"
                >
                  {pays.map(pays => (
                    <option key={pays} value={pays}>{pays}</option>
                  ))}
                </select>
              </div>
              
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Adresse
                </label>
                <textarea
                  value={tempRecipient.adresse}
                  onChange={(e) => setTempRecipient(prev => ({ ...prev, adresse: e.target.value }))}
                  placeholder="Adresse complète"
                  rows={3}
                  className="input-field"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Code postal
                </label>
                <input
                  type="text"
                  value={tempRecipient.postal_code}
                  onChange={(e) => setTempRecipient(prev => ({ ...prev, postal_code: e.target.value }))}
                  placeholder="13002"
                  className="input-field"
                  maxLength={10}
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Ville
                </label>
                <input
                  type="text"
                  value={tempRecipient.city}
                  onChange={(e) => setTempRecipient(prev => ({ ...prev, city: e.target.value }))}
                  placeholder="Marseille"
                  className="input-field"
                  maxLength={100}
                />
              </div>
              
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Notes
                </label>
                <textarea
                  value={tempRecipient.notes}
                  onChange={(e) => setTempRecipient(prev => ({ ...prev, notes: e.target.value }))}
                  placeholder="Notes sur le destinataire..."
                  rows={3}
                  className="input-field"
                />
              </div>
            </div>
            
            <div className="flex justify-end space-x-3">
              <button 
                onClick={() => {
                  setShowRecipientModal(false);
                  setEditingRecipient(null);
                  setTempRecipient({
                    label: '',
                    imo_number: '',
                    type: 'Company',
                    adresse: '',
                    postal_code: '',
                    city: '',
                    country: 'France',
                    notes: ''
                  });
                }} 
                className="btn-secondary"
              >
                Annuler
              </button>
              <button 
                onClick={handleRecipientSubmit}
                disabled={!tempRecipient.label}
                className="btn-primary"
              >
                {editingRecipient !== null ? 'Modifier' : 'Ajouter'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Contact */}
      {showContactModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-lg mx-4">
            <h3 className="text-lg font-semibold mb-4 flex items-center">
              <User className="h-5 w-5 mr-2" />
              {editingContact !== null ? 'Modifier le contact' : 'Nouveau contact'}
            </h3>
            
            <div className="space-y-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Nom *
                </label>
                <input
                  type="text"
                  value={tempContact.name}
                  onChange={(e) => setTempContact(prev => ({ ...prev, name: e.target.value }))}
                  placeholder="Nom complet"
                  className="input-field"
                  maxLength={100}
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  value={tempContact.email}
                  onChange={(e) => setTempContact(prev => ({ ...prev, email: e.target.value }))}
                  placeholder="email@example.com"
                  className="input-field"
                  maxLength={255}
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Téléphone
                </label>
                <input
                  type="tel"
                  value={tempContact.telephone}
                  onChange={(e) => setTempContact(prev => ({ ...prev, telephone: e.target.value }))}
                  placeholder="+33 1 23 45 67 89"
                  className="input-field"
                  maxLength={20}
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-port-gray-700 mb-2">
                  Notes
                </label>
                <textarea
                  value={tempContact.notes}
                  onChange={(e) => setTempContact(prev => ({ ...prev, notes: e.target.value }))}
                  placeholder="Notes sur le contact..."
                  rows={3}
                  className="input-field"
                />
              </div>
            </div>
            
            <div className="flex justify-end space-x-3">
              <button 
                onClick={() => {
                  setShowContactModal(false);
                  setEditingContact(null);
                  setTempContact({
                    name: '',
                    email: '',
                    telephone: '',
                    notes: ''
                  });
                }} 
                className="btn-secondary"
              >
                Annuler
              </button>
              <button 
                onClick={handleContactSubmit}
                disabled={!tempContact.name}
                className="btn-primary"
              >
                {editingContact !== null ? 'Modifier' : 'Ajouter'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModifierClient;
